export default {
  addressTitle: 'Adresse',
  currentAddressTitle: 'Adresse actuelle',
  PO: 'CP',
  RR: 'RR',
};
